import React from "react"
import { IDispatchRule } from "@/types/dispatchRules.types"
import { useTranslation } from "react-i18next"
import RuleFormModalButton from "../RuleFormModalButton/RuleFormModalButton.container"
import DispatchRuleCard from "./components/DispatchRuleCard/DispatchRuleCard"
import KosmoButton from "@/UI/Buttons/KosmoButton"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface IDispatchRulesListProps {
  dispatchRules: IDispatchRule[]
}

const DispatchRulesList: React.FC<IDispatchRulesListProps> = ({ dispatchRules }) => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col space-y-4">
      <div className="flex justify-end">
        <RuleFormModalButton
          button={
            <KosmoButton id="create-new-rule-button" type="primary">
              <div className="flex items-center gap-x-2">
                <FontAwesomeIcon icon={faPlus} color="#FFF" />
                <p>{t("profile.EmptySettingBox.createNewRule")}</p>
              </div>
            </KosmoButton>
          }
        />
      </div>
      {dispatchRules.map((rule) => (
        <DispatchRuleCard rule={rule} />
      ))}
    </div>
  )
}

export default DispatchRulesList
